import type { BaseQueryFn} from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query';
import { defaultTags, TagType } from './helpers/tag.helpers';

// Define a service using a base URL and expected endpoints
export const requestSlice = createApi<BaseQueryFn, any, string, string>({
  reducerPath: 'requests',
  baseQuery: fetchBaseQuery(),
  tagTypes: [...defaultTags, ...Object.keys(TagType).map(key => TagType[key])],
  endpoints: () => ({}),
});

export const endpoints = requestSlice.endpoints;
export const requestUtil = requestSlice.util;
